import React from 'react';

interface Props {
  onPointerDown: (e: React.PointerEvent<HTMLDivElement>) => void;
}

export function CookbookSidebarResizer({ onPointerDown }: Props) {
  return (
    <div
      onPointerDown={onPointerDown}
      className="absolute right-0 top-0 h-full w-1.5 cursor-ew-resize hover:bg-slate-500/50 transition-colors"
      style={{ 
        backgroundColor: 'rgba(100,116,139,0.25)',
        borderTopRightRadius: '0.75rem', 
        borderBottomRightRadius: '0.75rem' 
      }}
      title="Drag to resize sidebar"
    />
  );
}
